import React, { FC, ReactElement, ReactNode } from 'react';
import Typography from 'src/common/components/Typography';
import LocationFAQs from 'src/search/components/dockyard/LocationFAQs';
import styles from './PitchPageFAQ.module.scss';

type FAQ = {
  answer: ReactElement;
  question: string;
};

export type PitchPageFAQProps = {
  additionalText: ReactNode;
  faqs: FAQ[];
  title: string;
};

const PitchPageFAQ: FC<PitchPageFAQProps> = ({
  additionalText,
  faqs,
  title,
}) => (
  <div className={styles.root}>
    <div className={styles.title}>
      <Typography
        type="h3"
        size="display-5"
      >
        {title}
      </Typography>
    </div>
    <div className={styles.faqsWrapper}>
      {faqs.map((faq) => (
        <LocationFAQs key={faq.question} title={faq.question}>
          <div className={styles.faqAnswer}>
            {faq.answer}
          </div>
        </LocationFAQs>
      ))}
    </div>
    <div className={styles.text}>
      <Typography type="p" size="body-l">
        {additionalText}
      </Typography>
    </div>
  </div>
);

export default PitchPageFAQ;
